import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation UserLogin {
  logout
}`;

function logout() {
  return apollo.client.mutate({
    mutation,
  })
    .catch((err) => {
      throw err;
    });
}

export default logout;
